// This file replaced environment.ts file during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//// Uncomment for release
// export const environment = {
//  production: true,
//    services_url: '/ceq/api/',
//    service_version: 'v1/',
//    apiKey: '9af16994-91e2-49f8-9228-1de48b67718c',
//    firebase: {
//      apiKey: "AIzaSyAf4ud08PuvtXvy9m6iA-weNcHm2DG9JBo",
//      authDomain: "ceq-prod.firebaseapp.com",
//      databaseURL: "https://ceq-prod-default-rtdb.firebaseio.com",
//      projectId: "ceq-prod",
//      storageBucket: "ceq-prod.firebasestorage.app",
//      messagingSenderId: "390235701766",
//      appId: "1:390235701766:web:f3b6b1d6391d4760983987",
//      measurementId: "G-180F6VMJE0"
//    }
// };

// Comment for release
export const environment = {
  production: true,
  services_url: '/ceq/api/',
  apiKey: '9af16994-91e2-49f8-9228-1de48b67718c',
  service_version: 'v1/',
  firebase: {
    apiKey: "AIzaSyACK1age-KMUo_8NuRnqCVDn5965cXBl3E",
    authDomain: "ceq-dev-66f92.firebaseapp.com",
    databaseURL: "https://ceq-dev-66f92-default-rtdb.firebaseio.com",
    projectId: "ceq-dev-66f92",
    storageBucket: "ceq-dev-66f92.firebasestorage.app",
    messagingSenderId: "195636457571",
    appId: "1:195636457571:web:3138002bf2e0cd9cc0c856",
    measurementId: "G-DQ6H3ZHZQC"
  }
};
